/*
 *
 * anjiman constants
 *
 */
export const TOAST_ERROR = "app/TOAST_ERROR";
export const TOAST_SUCCESS = "app/TOAST_SUCCESS";
export const TOAST_WARNING = "app/TOAST_WARNING";

export const GET_CONVOCATION_LIST_REQUESTED = "ideation/GET_CONVOCATION_LIST_REQUESTED";
export const GET_CONVOCATION_LIST_SUCCESS = "ideation/GET_CONVOCATION_LIST_SUCCESS";
export const GET_CONVOCATION_LIST_FAILED = "ideation/GET_convocation_FAILED";

export const GET_ROLE_LIST_REQUESTED = "ideation/GET_ROLE_LIST_REQUESTED";
export const GET_ROLE_LIST_SUCCESS = "ideation/GET_ROLE_LIST_SUCCESS";
export const GET_ROLE_LIST_FAILED = "ideation/GET_convocation_FAILED";

export const GET_CONVOCATION_MENTOR_LIST_REQUESTED = "ideation/GET_CONVOCATION_MENTOR_LIST_REQUESTED";
export const GET_CONVOCATION_MENTOR_LIST_SUCCESS = "ideation/GET_CONVOCATION_MENTOR_LIST_SUCCESS";
export const GET_CONVOCATION_MENTOR_LIST_FAILED = "ideation/GET_convocation_MENTOR_FAILED";

export const GET_ACTIVE_IDEA_LIST_REQUESTED = "ideation/GET_ACTIVE_IDEA_LIST_REQUESTED";
export const GET_ACTIVE_IDEA_LIST_SUCCESS = "ideation/GET_ACTIVE_IDEA_LIST_SUCCESS";
export const GET_ACTIVE_IDEA_LIST_FAILED = "ideation/GET_ACTIVE_IDEA_LIST_FAILED";

export const GET_INACTIVE_IDEA_LIST_REQUESTED = "ideation/GET_INACTIVE_IDEA_LIST_REQUESTED";
export const GET_INACTIVE_IDEA_LIST_SUCCESS = "ideation/GET_INACTIVE_IDEA_LIST_SUCCESS";
export const GET_INACTIVE_IDEA_LIST_FAILED = "ideation/GET_INACTIVE_IDEA_LIST_FAILED";

export const GET_I_LINKED_IDEA_REQUESTED = "ideation/GET_I_LINKED_IDEA_REQUESTED";
export const GET_I_LINKED_IDEA_SUCCESS = "ideation/GET_I_LINKED_IDEA_SUCCESS";
export const GET_I_LINKED_IDEA_FAILED = "ideation/GET_I_LINKED_IDEA_FAILED";

export const GET_CONVOCATION_DETAIL_REQUESTED = "ideation/GET_CONVOCATION_DETAIL_REQUESTED";
export const GET_CONVOCATION_DETAIL_SUCCESS = "ideation/GET_CONVOCATION_DETAIL_SUCCESS";
export const GET_CONVOCATION_DETAIL_FAILED = "ideation/GET_CONVOCATION_DETAIL_FAILED";

export const GET_IDEA_DETAIL_REQUESTED = "ideation/GET_IDEA_DETAIL_REQUESTED";
export const GET_IDEA_DETAIL_SUCCESS = "ideation/GET_IDEA_DETAIL_SUCCESS";
export const GET_IDEA_DETAIL_FAILED = "ideation/GET_IDEA_DETAIL_FAILED";

export const GET_MY_CLASS_MATES_LIST_REQUESTED = "ideation/GET_MY_CLASS_MATES_LIST_REQUESTED";
export const GET_MY_CLASS_MATES_LIST_SUCCESS = "ideation/GET_MY_CLASS_MATES_LIST_SUCCESS";
export const GET_MY_CLASS_MATES_LIST_FAILED = "ideation/GET_MY_CLASS_MATES_LIST_FAILED";

export const GET_MY_RESERVED_IDEA_LIST_REQUESTED = "ideation/GET_MY_RESERVED_IDEA_LIST_REQUESTED";
export const GET_MY_RESERVED_IDEA_LIST_SUCCESS = "ideation/GET_MY_RESERVED_IDEA_LIST_SUCCESS";
export const GET_MY_RESERVED_IDEA_LIST_FAILED = "ideation/GET_MY_RESERVED_IDEA_LIST_FAILED";

export const RESET_INACTIVE_IDEA_DETAIL = "ideation/RESET_INACTIVE_IDEA_DETAIL";

export const RESET_MY_IDEA_LIST = "ideation/RESET_MY_IDEA_LIST";

export const GET_MY_IDEA_LIST_REQUESTED = "ideation/GET_MY_IDEA_LIST_REQUESTED";
export const GET_MY_IDEA_LIST_SUCCESS = "ideation/GET_MY_IDEA_LIST_SUCCESS";
export const GET_MY_IDEA_LIST_FAILED = "ideation/GET_MY_IDEA_LIST_FAILED";

export const ADD_UPDATE_CONVOCATION_REQUESTED = "ideation/ADD_UPDATE_CONVOCATION_REQUESTED";
export const ADD_UPDATE_CONVOCATION_SUCCESS = "ideation/ADD_UPDATE_CONVOCATION_SUCCESS";
export const ADD_UPDATE_CONVOCATION_FAILED = "ideation/ADD_UPDATE_CONVOCATION_FAILED";

export const ADD_UPDATE_APPENDIX_CONVOCATION_REQUESTED = "ideation/ADD_UPDATE_APPENDIX_CONVOCATION_REQUESTED";
export const ADD_UPDATE_APPENDIX_CONVOCATION_SUCCESS = "ideation/ADD_UPDATE_APPENDIX_CONVOCATION_SUCCESS";
export const ADD_UPDATE_APPENDIX_CONVOCATION_FAILED = "ideation/ADD_UPDATE_APPENDIX_CONVOCATION_FAILED";

export const REMOVE_APPENDIX_CONVOCATION_REQUESTED = "ideation/REMOVE_APPENDIX_CONVOCATION_REQUESTED";
export const REMOVE_APPENDIX_CONVOCATION_SUCCESS = "ideation/REMOVE_APPENDIX_CONVOCATION_SUCCESS";
export const REMOVE_APPENDIX_CONVOCATION_FAILED = "ideation/REMOVE_APPENDIX_CONVOCATION_FAILED";

export const ADD_CONVOCATION_MENTOR_REQUESTED = "ideation/ADD_CONVOCATION_MENTOR_REQUESTED";
export const ADD_CONVOCATION_MENTOR_SUCCESS = "ideation/ADD_CONVOCATION_MENTOR_SUCCESS";
export const ADD_CONVOCATION_MENTOR_FAILED = "ideation/ADD_CONVOCATION_MENTOR_FAILED";

export const REMOVE_CONVOCATION_MENTOR_REQUESTED = "ideation/REMOVE_CONVOCATION_MENTOR_REQUESTED";
export const REMOVE_CONVOCATION_MENTOR_SUCCESS = "ideation/REMOVE_CONVOCATION_MENTOR_SUCCESS";
export const REMOVE_CONVOCATION_MENTOR_FAILED = "ideation/REMOVE_CONVOCATION_MENTOR_FAILED";

export const TOGGLE_IDEA_STATUS_REQUESTED = "ideation/TOGGLE_IDEA_STATUS_REQUESTED";
export const TOGGLE_IDEA_STATUS_SUCCESS = "ideation/TOGGLE_IDEA_STATUS_SUCCESS";
export const TOGGLE_IDEA_STATUS_FAILED = "ideation/TOGGLE_IDEA_STATUS_FAILED";

export const TOGGLE_IDEA_LIKE_REQUESTED = "ideation/TOGGLE_IDEA_LIKE_REQUESTED";
export const TOGGLE_IDEA_LIKE_SUCCESS = "ideation/TOGGLE_IDEA_LIKE_SUCCESS";
export const TOGGLE_IDEA_LIKE_FAILED = "ideation/TOGGLE_IDEA_LIKE_FAILED";

export const IDEA_SAVE_REQUESTED = "ideation/IDEA_SAVE_REQUESTED";
export const IDEA_SAVE_SUCCESS = "ideation/IDEA_SAVE_SUCCESS";
export const IDEA_SAVE_FAILED = "ideation/IDEA_SAVE_FAILED";

export const ADD_UPDATE_IDEA_REQUESTED = "ideation/ADD_UPDATE_IDEA_REQUESTED";
export const ADD_UPDATE_IDEA_SUCCESS = "ideation/ADD_UPDATE_IDEA_SUCCESS";
export const ADD_UPDATE_IDEA_FAILED = "ideation/ADD_UPDATE_IDEA_FAILED";

export const REMOVE_IDEA_REQUESTED = "ideation/REMOVE_IDEA_REQUESTED";
export const REMOVE_IDEA_SUCCESS = "ideation/REMOVE_IDEA_SUCCESS";
export const REMOVE_IDEA_FAILED = "ideation/REMOVE_IDEA_FAILED";

export const IDEA_MENTORING_REQUESTED = "ideation/IDEA_MENTORING_REQUESTED";
export const IDEA_MENTORING_SUCCESS = "ideation/IDEA_MENTORING_SUCCESS";
export const IDEA_MENTORING_FAILED = "ideation/IDEA_MENTORING_FAILED";

export const IDEA_ACCEPT_REQUESTED = "ideation/IDEA_ACCEPT_REQUESTED";
export const IDEA_ACCEPT_SUCCESS = "ideation/IDEA_ACCEPT_SUCCESS";
export const IDEA_ACCEPT_FAILED = "ideation/IDEA_ACCEPT_FAILED";

export const IDEA_LIKE_DISLIKE_REQUESTED = "ideation/IDEA_LIKE_DISLIKE_REQUESTED";
export const IDEA_LIKE_DISLIKE_SUCCESS = "ideation/IDEA_LIKE_DISLIKE_SUCCESS";
export const IDEA_LIKE_DISLIKE_FAILED = "ideation/IDEA_LIKE_DISLIKE_FAILED";

export const IDEA_NEW_CHAT_REQUESTED = "ideation/IDEA_NEW_CHAT_REQUESTED";
export const IDEA_NEW_CHAT_SUCCESS = "ideation/IDEA_NEW_CHAT_SUCCESS";
export const IDEA_NEW_CHAT_FAILED = "ideation/IDEA_NEW_CHAT_FAILED";

export const IDEA_CHAT_SEEN_REQUESTED = "ideation/IDEA_CHAT_SEEN_REQUESTED";
export const IDEA_CHAT_SEEN_SUCCESS = "ideation/IDEA_CHAT_SEEN_SUCCESS";
export const IDEA_CHAT_SEEN_FAILED = "ideation/IDEA_CHAT_SEEN_FAILED";

export const IDEA_RESERVE_OR_REMOVE_RESERVE_REQUESTED = "ideation/IDEA_RESERVE_OR_REMOVE_RESERVE_REQUESTED";
export const IDEA_RESERVE_OR_REMOVE_RESERVE_SUCCESS = "ideation/IDEA_RESERVE_OR_REMOVE_RESERVE_SUCCESS";
export const IDEA_RESERVE_OR_REMOVE_RESERVE_FAILED = "ideation/IDEA_RESERVE_OR_REMOVE_RESERVE_FAILED";

export const RESET_IDEA_LIST = "ideation/RESET_IDEA_LIST";
